import React from 'react'
import createReactClass from 'create-react-class'
import './info-panel.scss'

export default createReactClass({
  onCloseButtonClick () {
    clearTimeout(this.timeout)
    if (this.infoAlertNode) {
      this.infoAlertNode.classList.add('fadeOut')
    }
    this.props.unMountInfoPanel()
  },

  render () {
    let {infoError} = this.props
    return (
      <div className={infoError ? 'info-alert error' : 'info-alert'} ref={(node) => { this.infoAlertNode = node }}>
        <div className='close-button' onClick={this.onCloseButtonClick}>x</div>
        <div className='info-alert-message'>{this.props.message}</div>
      </div>
    )
  },
  componentDidMount () {
    this.timeout = setTimeout(this.onCloseButtonClick, 5000)
  },
  componentWillUnmount () {
    clearTimeout(this.timeout)
    if (this.infoAlertNode) {
      this.infoAlertNode.classList.add('fadeOut')
    }
  },
})



// WEBPACK FOOTER //
// ./src/components/info-panel.js